import { useMaskito } from '@maskito/react';
import { maskitoNumberOptionsGenerator } from '@maskito/kit';
import { FormEventHandler, ReactNode, useState } from 'react';
import { Input, InputProps } from '@/components/ui/input';

const numberMaskingOptions = maskitoNumberOptionsGenerator({
  thousandSeparator: '.',
  precision: 2,
  decimalSeparator: ',',
  min: 0,
});

export function FloatNumberInput(
  props: InputProps & {
    onInput?: FormEventHandler<HTMLInputElement>;
    unit?: ReactNode;
  },
) {
  const inputRef = useMaskito({ options: numberMaskingOptions });
  const [focus, setFocus] = useState(false);
  const { onInput, onBlur = undefined, className, ...otherProps } = props;

  return (
    <div className="flex items-center relative">
      <div className="grow">
        <Input
          onFocus={() => {
            setFocus(true);
          }}
          {...otherProps}
          className={`min-w-full grow ${className}`}
          ref={inputRef}
          onInput={onInput}
          onBlur={(e) => {
            setFocus(false);
            onBlur?.(e);
          }}
        />
      </div>
      {props.unit && (
        <span
          className={`${
            focus ? 'text-primary-blue-B600' : 'text-neutrals-N700'
          } font-extralight mr-4 absolute right-0`}>
          {props.unit}
        </span>
      )}
    </div>
  );
}
